import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { marcaService, Marca } from '../../services/marca';

interface SelectMarcaProps {
  value?: number;
  onChange: (value: number) => void;
  label?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
}

const SelectMarca: React.FC<SelectMarcaProps> = ({
  value,
  onChange,
  label = 'Marca',
  required = false,
  error = false,
  helperText,
  disabled = false,
  fullWidth = true,
}) => {
  const { data: marcas = [], isLoading } = useQuery({
    queryKey: ['marcas'],
    queryFn: marcaService.getAll,
  });

  const handleChange = (event: any) => {
    onChange(Number(event.target.value));
  };

  return (
    <FormControl fullWidth={fullWidth} required={required} error={error} disabled={disabled}>
      <InputLabel id="marca-label">{label}</InputLabel>
      <Select
        labelId="marca-label"
        value={value || ''}
        onChange={handleChange}
        label={label}
        disabled={isLoading || disabled}
      >
        {marcas.map((marca) => (
          <MenuItem key={marca.id} value={marca.id}>
            {marca.nome}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default SelectMarca;
